import { createContext, Ref } from 'react';

const PageBuilderContext = createContext<{
  pageRef?: Ref<HTMLDivElement>;
}>({});

export default PageBuilderContext;
